import Head from "next/head";
import React, { useState, useRef } from "react";
import css from "./index.module.scss";
import Header from "sections/header/index.jsx";
import Footer from "sections/footer";
import SigninForm from "forms/auth/signin";
import DefaultLayout from "layouts/default";

export default function SignInPage({ }) {
  const title = "Sign In | X";
  const description = "Sign In | X";


  return <DefaultLayout title="Sign In | Lazy Prompts" description="Sign in to buy and sell prompts.">
    <section className={`light ${css.signin}`}>
      <div className={css.inner}>
        <SigninForm/>
      </div>
    </section>

  </DefaultLayout>;
}
